import { render, staticRenderFns } from "./AdminTeacherSatisfactionByTeacher.vue?vue&type=template&id=589125ec&scoped=true&"
import script from "./AdminTeacherSatisfactionByTeacher.vue?vue&type=script&lang=js&"
export * from "./AdminTeacherSatisfactionByTeacher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "589125ec",
  null
  
)

export default component.exports